import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/alloy-react-locale';
import { COMPONENT_VARIANTS } from '@adsk/acs-admin-ui-components-helpers';
import {
  emailOptionStyle,
  nameStyle,
  emailStyle,
  messageStyle,
} from './helpers/styles';

const EmailOption = ({
  allowReinviting,
  email,
  name,
  userInProject,
  variant,
}) => {
  const isOrgLevelModal = variant === COMPONENT_VARIANTS.ACCOUNT;
  const isProjectModal = variant === COMPONENT_VARIANTS.PROJECT;
  const isExistingUser = isOrgLevelModal || userInProject;
  const allowReinvitingDisabled =
    isProjectModal && userInProject && !allowReinviting;
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));
  const message = isOrgLevelModal
    ? T.translate('USER_IN_ORGANIZATION_MESSAGE')
    : T.translate('USER_IN_PROJECT_MESSAGE');

  return (
    <div css={emailOptionStyle}>
      <div css={nameStyle(isOrgLevelModal || allowReinvitingDisabled)}>
        {name}
      </div>
      <div css={emailStyle(isOrgLevelModal || allowReinvitingDisabled)}>
        {email}
      </div>
      {isExistingUser && (
        <div css={messageStyle(allowReinviting && !isOrgLevelModal)}>
          {message}
        </div>
      )}
    </div>
  );
};

EmailOption.propTypes = {
  email: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  userInProject: PropTypes.bool.isRequired,
  variant: PropTypes.oneOf(Object.values(COMPONENT_VARIANTS)),
  allowReinviting: PropTypes.bool,
};

EmailOption.defaultProps = {
  variant: COMPONENT_VARIANTS.PROJECT,
  allowReinviting: false,
};

export default EmailOption;
